export default {
  name: 'eighth',
  data: function() {
    return {
      showerNumber: 0,
      bathtubNumber: 0,
      toiletNumber: 0
    }
  },
  props: ['installed_appliances', 'landingText'],
  methods: {
    goToNinth: function() {
      this.$emit('change-component', 'nineth-component', this.installed_appliances)
    }
  },
  watch: {
    showerNumber: function() {
      if (this.showerNumber < 0) {
        this.showerNumber = 0
        this.installed_appliances.shower = this.showerNumber
      } else {
        this.installed_appliances.shower = this.showerNumber
      }
    },
    bathtubNumber: function() {
      if (this.bathtubNumber < 0) {
        this.bathtubNumber = 0
        this.installed_appliances.bath_tub = this.bathtubNumber
      } else {
        this.installed_appliances.bath_tub = this.bathtubNumber
      }
    },
    toiletNumber: function() {
      if (this.toiletNumber < 0) {
        this.toiletNumber = 0
        this.installed_appliances.toilets = this.toiletNumber
      } else {
        this.installed_appliances.toilets = this.toiletNumber
      }
    }
  },
  beforeMount: function() {
    this.showerNumber = this.installed_appliances.shower
    this.bathtubNumber = this.installed_appliances.bath_tub
    this.toiletNumber = this.installed_appliances.toilets
  },
  mounted: function() {
    this.showerNumber = this.installed_appliances.shower
    this.bathtubNumber = this.installed_appliances.bath_tub
    this.toiletNumber = this.installed_appliances.toilets
  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/eighth/eighth.js